export default "__VITE_ASSET__faa11162__"